var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPedestrian(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 4.47V3.53C9.99757 3.12858 10.1538 2.74241 10.4348 2.45576C10.7158 2.16911 11.0989 2.00527 11.5002 2C11.6981 1.9998 11.894 2.03956 12.0761 2.11688C12.2583 2.19421 12.4229 2.30751 12.5602 2.45C12.8419 2.739 12.9998 3.12645 13.0002 3.53V4.47C13.0002 4.86783 12.8422 5.24936 12.5609 5.53066C12.2796 5.81197 11.8981 5.97 11.5002 5.97C11.1024 5.97 10.7209 5.81197 10.4396 5.53066C10.1583 5.24936 10.0002 4.86783 10.0002 4.47ZM13.2202 7H9.78025C9.52822 7.00278 9.27955 7.05817 9.05016 7.16262C8.82078 7.26707 8.61574 7.41828 8.44817 7.60655C8.2806 7.79483 8.15421 8.01603 8.07707 8.25598C7.99994 8.49593 7.97377 8.74935 8.00025 9V14H10.0002V22H13.0002V14H15.0002V9C15.0276 8.49919 14.8558 8.00788 14.5224 7.63321C14.1889 7.25855 13.7209 7.03093 13.2202 7Z",
    fill: "#00000099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedestrian);
export default __webpack_public_path__ + "static/media/pedestrian.b20b2ae9b6138b953b99b97c204569b3.svg";
export { ForwardRef as ReactComponent };